
import { UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { RiskQuestion } from './RiskQuestion';
import type { Application } from '@/types/database.types';

interface RiskAssessmentProps {
  register: UseFormRegister<Partial<Application>>;
  setValue: UseFormSetValue<Partial<Application>>;
  watch: UseFormWatch<Partial<Application>>;
}

export const RiskAssessment = ({ register, setValue, watch }: RiskAssessmentProps) => {
  return (
    <div className="space-y-4">
      <RiskQuestion
        id="has_over_road_trucking"
        label="Does your business have over-the-road trucking exposure?"
        register={register}
        setValue={setValue}
        watch={watch}
      />
      
      <RiskQuestion
        id="has_cannabis_hemp_contact"
        label="Does your business have cannabis or hemp contact?"
        register={register}
        setValue={setValue}
        watch={watch}
        detailsField="cannabis_hemp_details"
        detailsPlaceholder="Please describe your business's involvement with cannabis or hemp..."
      />
      
      <RiskQuestion
        id="has_elevated_workplace_risk"
        label="Does your business have elevated workplace risks?"
        register={register}
        setValue={setValue}
        watch={watch}
        detailsField="workplace_risk_details"
        detailsPlaceholder="Please describe the elevated workplace risks..."
      />
      
      <RiskQuestion
        id="has_company_aircraft"
        label="Does your business operate aircraft?"
        register={register}
        setValue={setValue}
        watch={watch}
      />
      
      <RiskQuestion
        id="has_marine_operations"
        label="Does your business have marine exposures (work on vessels/docks/piers)?"
        register={register}
        setValue={setValue}
        watch={watch}
      />
      
      <RiskQuestion
        id="has_heavy_machinery"
        label="Does your business utilize heavy machinery?"
        register={register}
        setValue={setValue}
        watch={watch}
      />
      
      <RiskQuestion
        id="has_recent_wc_claims"
        label="Has your business had any workers comp claims in the past 5 years?"
        register={register}
        setValue={setValue}
        watch={watch}
      />
      
      <RiskQuestion
        id="has_safety_program"
        label="Does your company have a formal safety program?"
        register={register}
        setValue={setValue}
        watch={watch}
        detailsField="safety_program_details"
        detailsPlaceholder="Please describe your safety program..."
      />
    </div>
  );
};
